import { Factory, trait } from 'miragejs';
import moment from 'moment-timezone';
import { APP } from 'garaje/utils/enums';

export default Factory.extend({
  app: 'visitors',
  employeeLimit: 'Infinity',
  locationLimit: 'Infinity',
  quantity: 1,
  status: 'active',
  subscribed: true,

  traitOnTrial: trait({
    status: 'in_trial',
    afterCreate(locationSubscription) {
      const { app, billingCompany } = locationSubscription;
      const trialEndDate = moment().add(14, 'days').toDate();

      billingCompany.trialEnd[app] = trialEndDate;
      locationSubscription.update({ trialEndDate });
    },
  }),

  traitRoomsStandard: trait({
    quantity: 1,
    afterCreate(locationSubscription, server) {
      const { billingCompany } = locationSubscription;
      const subscriptionPlan = server.schema.find('subscription-plan', 'rooms-standard-monthly-calendar-billing');

      // TODO: backend is sideloading this data, and billingCompany.subscriptionPlans
      // should really only contain one subscriptionPlan for each app type.
      if (!billingCompany.subscriptionPlans.includes(subscriptionPlan)) {
        billingCompany.subscriptionPlans.add(subscriptionPlan);
        billingCompany.save();
      }

      locationSubscription.update({
        app: APP.ROOMS,
        subscriptionPlan,
      });
    },
  }),

  traitVisitorsPremium: trait({
    quantity: 1,
    afterCreate(locationSubscription, server) {
      const { billingCompany } = locationSubscription;
      const subscriptionPlan = server.schema.find('subscription-plan', 'visitors-premium-monthly-calendar-billing');

      // TODO: backend is sideloading this data, and billingCompany.subscriptionPlans
      // should really only contain one subscriptionPlan for each app type.
      if (!billingCompany.subscriptionPlans.includes(subscriptionPlan)) {
        billingCompany.subscriptionPlans.add(subscriptionPlan);
        billingCompany.save();
      }

      locationSubscription.update({
        app: APP.VISITORS,
        subscriptionPlan,
      });
    },
  }),

  traitRoomsTrial: trait({
    quantity: 1,
    status: 'in_trial',
    employeeLimit: 'Infinity',
    locationLimit: 'Infinity',
    trialEndDate: moment().add(5, 'days').utc(),

    afterCreate(locationSubscription, server) {
      const { billingCompany } = locationSubscription;
      const subscriptionPlan = server.schema.find('subscription-plan', 'rooms-standard-yearly-calendar-billing');

      // TODO: backend is sideloading this data, and billingCompany.subscriptionPlans
      // should really only contain one subscriptionPlan for each app type.
      if (!billingCompany.subscriptionPlans.includes(subscriptionPlan)) {
        billingCompany.subscriptionPlans.add(subscriptionPlan);
        billingCompany.save();
      }

      locationSubscription.update({
        app: APP.ROOMS,
        subscriptionPlan,
      });
    },
  }),

  traitVisitorsOnTrial: trait({
    quantity: 1,
    status: 'in_trial',
    employeeLimit: 'Infinity',
    locationLimit: 'Infinity',
    trialEndDate: moment().add(5, 'days').utc(),

    afterCreate(locationSubscription, server) {
      const { billingCompany } = locationSubscription;
      const subscriptionPlan = server.schema.find('subscription-plan', 'visitors-standard-yearly-calendar-billing');

      // TODO: backend is sideloading this data, and billingCompany.subscriptionPlans
      // should really only contain one subscriptionPlan for each app type.
      if (!billingCompany.subscriptionPlans.includes(subscriptionPlan)) {
        billingCompany.subscriptionPlans.add(subscriptionPlan);
        billingCompany.save();
      }

      locationSubscription.update({
        app: APP.VISITORS,
        subscriptionPlan,
      });
    },
  }),
});
